import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "popup-dialog flex transition-all max-w-[550px] min-h-full items-center mx-auto" }
const _hoisted_2 = { class: "trezo-card w-full bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_3 = { class: "trezo-card-header bg-gray-50 dark:bg-[#15203c] mb-[20px] md:mb-[25px] flex items-center justify-between -mx-[20px] md:-mx-[25px] -mt-[20px] md:-mt-[25px] p-[20px] md:p-[25px] rounded-t-md" }
const _hoisted_4 = { class: "trezo-card-title" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "trezo-card-subtitle" }
const _hoisted_7 = { class: "trezo-card-content" }
const _hoisted_8 = {
  key: 0,
  class: "mb-4 p-3 bg-red-50 text-red-500 rounded-md"
}
const _hoisted_9 = { class: "sm:grid sm:grid-cols-2 sm:gap-[25px]" }
const _hoisted_10 = { class: "sm:col-span-2 mb-[20px] sm:mb-0" }
const _hoisted_11 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_14 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_17 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_20 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_23 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_24 = { value: "new" }
const _hoisted_25 = { value: "in progress" }
const _hoisted_26 = { value: "on hold" }
const _hoisted_27 = { value: "pending" }
const _hoisted_28 = { value: "negotiation" }
const _hoisted_29 = { value: "closed" }
const _hoisted_30 = { class: "sm:col-span-2 mb-[20px] sm:mb-0" }
const _hoisted_31 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = { class: "mt-[20px] md:mt-[25px] ltr:text-right rtl:text-left" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 0,
  class: "inline-block relative ltr:pl-[25px] rtl:pr-[25px]"
}
const _hoisted_36 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'add-new-popup z-[999] fixed transition-all inset-0 overflow-x-hidden overflow-y-auto lg:py-[20px]',
      { active: _ctx.stateStoreInstance.active },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.directT('crm.deals.form.title')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "text-[23px] transition-all leading-none text-black dark:text-white hover:text-primary-500",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "ri-close-fill" }, null, -1)
            ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveDeal && _ctx.saveDeal(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.directT('crm.deals.form.dealTitle')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newDeal.title) = $event)),
                  type: "text",
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: _ctx.directT('crm.deals.form.dealTitlePlaceholder'),
                  required: ""
                }, null, 8, _hoisted_12), [
                  [_vModelText, _ctx.newDeal.title]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.directT('crm.deals.form.contactPerson')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newDeal.name) = $event)),
                  type: "text",
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: _ctx.directT('crm.deals.form.contactPersonPlaceholder'),
                  required: ""
                }, null, 8, _hoisted_15), [
                  [_vModelText, _ctx.newDeal.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.directT('crm.deals.form.phone')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newDeal.phone) = $event)),
                  type: "text",
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: _ctx.directT('crm.deals.form.phonePlaceholder')
                }, null, 8, _hoisted_18), [
                  [_vModelText, _ctx.newDeal.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.directT('crm.deals.form.amount')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newDeal.amount) = $event)),
                  type: "number",
                  step: "0.01",
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: _ctx.directT('crm.deals.form.amountPlaceholder')
                }, null, 8, _hoisted_21), [
                  [_vModelText, _ctx.newDeal.amount]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.directT('crm.deals.form.status')), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newDeal.status) = $event)),
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500",
                  required: ""
                }, [
                  _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.new')), 1),
                  _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.inProgress')), 1),
                  _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.onHold')), 1),
                  _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.pending')), 1),
                  _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.negotiation')), 1),
                  _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.closed')), 1)
                ], 512), [
                  [_vModelSelect, _ctx.newDeal.status]
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.directT('crm.deals.form.description')), 1),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newDeal.description) = $event)),
                  rows: "3",
                  class: "rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] p-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: _ctx.directT('crm.deals.form.descriptionPlaceholder')
                }, null, 8, _hoisted_32), [
                  [_vModelText, _ctx.newDeal.description]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("button", {
                type: "button",
                class: "rounded-md inline-block transition-all font-medium ltr:mr-[15px] rtl:ml-[15px] px-[26.5px] py-[12px] bg-danger-500 text-white hover:bg-danger-400",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
              }, _toDisplayString(_ctx.directT('crm.deals.form.cancel')), 1),
              _createElementVNode("button", {
                type: "submit",
                class: "inline-block bg-primary-500 text-white py-[12px] px-[26.5px] transition-all rounded-md hover:bg-primary-400",
                disabled: _ctx.loading
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                      _cache[10] || (_cache[10] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2" }, " add ", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.create')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.directT('crm.deals.form.saving')), 1))
              ], 8, _hoisted_34)
            ])
          ], 32)
        ])
      ])
    ])
  ], 2))
}